import React, { useLayoutEffect, useRef } from 'react';
import html2canvas from 'html2canvas';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { isGrounds, shareAppWebCard } from '@src/public/utils/app';
import styles from './index.css';
import { ListStore } from '../store';
import Item from './Item';
import topLongLogo from '../../assets/topLongLogo.png';

const ShareLongImg = () => {
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { title, nodes, parties, qrcode } = listStates;

    const sourceRef = useRef();

    useLayoutEffect(() => {
        if (isGrounds && sourceRef.current) {
            html2canvas(sourceRef.current, { useCORS: true }).then(canvas => {
                const data = canvas.toDataURL('image/png');

                shareAppWebCard(data);
                changeListStates({ showShareLongImg: false });
            });
        }
    }, []);

    return (
        <div className={styles.wrap}>
            <div className={styles.source} ref={sourceRef}>
                <div className={styles.header}>
                    <div className={styles.topLongLogo}>
                        <img src={topLongLogo} alt="" />
                    </div>
                    <div className={styles.title}>{title}</div>
                </div>
                <div className={styles.content}>
                    <div className={styles.tags}>
                        {parties.slice(1).map(item => {
                            const { id, name, color } = item;

                            return (
                                <div className={styles.tag} key={id} style={{ color, borderColor: color }}>
                                    {name}
                                </div>
                            );
                        })}
                    </div>
                    <div className={styles.listWrap}>
                        <div className={styles.list}>
                            {nodes.slice(0, 10).map(item => <Item content={{ item, parties }} key={item.id} />)}
                        </div>
                        <div className={styles.more}>
                            <div className={styles.moreTrans} />
                            <div className={styles.moreText}>
                                <div className={styles.moreTextBe} />
                                <div className={styles.moreTextFe}>扫码查看更多</div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.qrcode}>
                        <div className={styles.qrcodeImg}>
                            <img src={qrcode} alt="" />
                        </div>
                        <div className={styles.qrcodeText}>扫描二维码，查看完整事件</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default errorBoundary(ShareLongImg);
